<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <section>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Email Subject</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  v-model="form.email_subject"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("email_subject")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Email Title</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  v-model="form.email_title"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("email_title")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Email Intro</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea class="w-full" v-model="form.email_intro" />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("email_intro")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Button Text</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  v-model="form.cta_buttontext"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("cta_buttontext")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Link Type</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="cta_url_type"
                      v-model="form.cta_url_type"
                      :vs-value="`url`"
                      >URL</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="cta_url_type"
                      v-model="form.cta_url_type"
                      :vs-value="`ticket`"
                      >Ticket Join Page</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="cta_url_type"
                      v-model="form.cta_url_type"
                      :vs-value="`form`"
                      >Ticket Form Page</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-row mb-6" v-if="form.cta_url_type == 'url'">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Link</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="name"
                  class="w-full"
                  v-model="form.cta_url"
                />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("cta_url")
                }}</span>
              </div>
            </div>

            <div class="vx-row mb-6" v-if="form.cta_url_type == 'form'">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Select Form</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                  class="selectExample"
                  style="width:100%;"
                  v-model="form.cta_url_reference"
                >
                  <vs-select-item
                    :key="c"
                    :value="choice.form_id"
                    :text="choice.form_title"
                    v-for="(choice, c) in formList"
                  />
                </vs-select>
              </div>
            </div>
            <div class="vx-row pt-5">
              <div class="vx-col sm:w-2/3 w-full ml-auto">
                <vs-button
                  :disabled="!valid"
                  class="mr-3 mb-2"
                  @click.prevent="validateForm"
                  >Create Attendee Message</vs-button
                >
              </div>
            </div>
          </section>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";
import { mapState } from "vuex";

const dict = {
  form: {
    name: {
      required: "Please enter an event name"
    },
    slug: {
      required: "Please enter your last name",
      alpha: "Your last name may only contain alphabetic characters"
    }
  }
};

// register custom messages
Validator.localize("en", dict);

export default {
  components: {},
  data: () => ({
    valid: true,
    form: {
      e: null,
      email_subject: "",
      email_title: "",
      email_intro: "",
      listing_status: true,
      publish_status: true,
      cta_url_type: "url",
      cta_url: "",
      cta_buttontext: "",
      button_text: "",
      cta_url_reference: null
    },
    formList: []
  }),
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  created() {
    setTimeout(() => {
      this.fetchData();
    }, 1000);
  },
  methods: {
    fetchData() {
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s,
        perPage: 100,
        form_id: this.form_id
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");
      Service.Question.gets(params).then(res => {
        this.formList = res.data.rows;
      });
    },
    validateForm() {
      this.form.button_text = this.form.cta_buttontext;

      this.$validator.validateAll().then(result => {
        if (result) {
          // if form have no errors
          this.form.e = this.e;
          this.onSubmit();
        } else {
          // form have errors
        }
      });
    },
    onSubmit() {
      this.$vs.loading();
      Service.AttendeeMessage.create(this.form)
        .then(res => {
          this.$vs.loading.close();
          this.$router.push(
            "/events/" +
              this.e +
              "/attendee_messages?e=" +
              this.e +
              "&s=" +
              this.s
          );
        })
        .catch(e => {
          console.log(e);
          this.$vs.loading.close();
        });
    }
  }
};
</script>
